import { getUsersToAssign } from '@api/users/users.service';
import { useQuery } from '@tanstack/react-query';
import { getTableRequest } from '@shared/utils';

export const useUsers = (search: string, pageSize: number = 5) => {
  const request = getTableRequest({ pagination: { pageSize }, search });

  const { data, isLoading: isLoadingUsersOptions } = useQuery({
    queryKey: ['users', request],
    queryFn: () => getUsersToAssign(request),
  });
  return { usersOptions: data?.data ?? [], isLoadingUsersOptions };
};
